import { IMeta } from '@models/IMeta';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props {
  readonly subheader: string;
  readonly body: string;
  readonly meta?: IMeta;
  readonly index: number;
}

const SubheaderCard = ({ subheader, body, meta, index }: Props) => {
  const isMobile = useMediaQuery(768);
  return (
    <div
      className={classNames('col-span-1 flex flex-col gap-2.5 lg:gap-5', {
        'bg-white': meta?.editMode,
      })}
      key={`${subheader}-${body}`}
      data-testid={`CT-160-Subheader-Cards-Card-${index}`}
      data-epi-block-id={meta?.contentLink}
    >
      <p
        className="h6"
        data-testid={`CT-160-Subheader-Cards-Card-${index}-Subheader`}
        data-epi-property-name={meta?.editHints?.subheader}
      >
        {subheader}
      </p>
      <p
        className={classNames(
          isMobile ? 'body-three' : 'body-two',
          'text-grey-600'
        )}
        data-testid={`CT-160-Subheader-Cards-Card-${index}-Body`}
        data-epi-property-name={meta?.editHints?.body}
      >
        {body}
      </p>
    </div>
  );
};

export default SubheaderCard;
